
angular.module('membership')
  .controller('UserPermissionsCtrl', ['$scope', '$stateParams', 'userPermissionsViewModel',
    function ($scope, $stateParams, model) {
      //$scope.model = model;
      //$scope.model.init($scope.userId);
      $scope.model = new model($stateParams.id);
    }
  ]);